import objectMaps from '@/modules/mixins/objectMaps'
import { isOffsetLessWindowValue, parseWindowValue } from '@/modules/helpers/estimatedWindow'

const WINDOW_DIFF_KEYS = ['estimated_window_from', 'estimated_window_to']

export default {
    mixins: [objectMaps],
    data() {
        return {
            channelTracker: null,
            channelOrder: null,
            channelNameTracker: null,
            channelNameOrder: null,
            logToConsole: false,
            namespace: 'summary',
            thirdPartyOrderVariables: [
                'third_party_order_id',
                'restaurant_third_party_type',
                'third_party_tracking_url',
                'third_party_code',
            ],
        }
    },
    methods: {
        async subscribeOrderChannel(id) {
            if (!this.pusher) this.initializePusher()
            this.channelNameOrder = `private-orders-orders-${id}`
            this.channelOrder = await this.pusher.subscribe(this.channelNameOrder)
            this.channelOrder.bind('update-order', this.updateOrder)
        },

        subscribeTrackerChannel(id) {
            if (!this.pusher) this.initializePusher()
            this.channelNameTracker = `private-delivery-jobs-${id}`
            this.channelTracker = this.pusher.subscribe(this.channelNameTracker)
            this.channelTracker.bind('update-delivery-job', this.updateTracker)
        },

        unsubscribeOrderChannel() {
            if (this.channelNameOrder) {
                this.channelOrder.unbind('update-order')
                this.channelOrder = this.pusher.unsubscribe(this.channelNameOrder)
            }
        },

        unsubscribeTrackerChannel() {
            if (this.channelNameTracker) {
                this.channelTracker.unbind('update-delivery-job')
                this.channelTracker = this.pusher.unsubscribe(this.channelNameTracker)
            }
        },

        async updateStatus() {
            // a courier cancel/error shows "updating delivery"; any later in-progress or finished state ends it
            if (
                this.$store.getters[`${this.namespace}/waitingForUpdate`] &&
                (this.$store.getters[`${this.namespace}/deliveryInProgress`] ||
                    this.$store.getters[`${this.namespace}/deliveryFinished`])
            )
                await this.$store.dispatch(`${this.namespace}/setUpdateStatus`, false)
        },

        // tasks#202: binlog window values are offset-less application time; they are stored as RFC3339 like the HTTP
        // values. Without the application timezone they are not merged and the page re-fetches its snapshot.
        prepareWindowDiff(data) {
            const prepared = { ...data }
            let refetch = false
            WINDOW_DIFF_KEYS.forEach((key) => {
                if (!(key in prepared)) return
                const value = prepared[key]?.new
                if (value === null || value === undefined || !isOffsetLessWindowValue(value)) return
                const parsed = parseWindowValue(value, this.$store.getters['site/timezone'])
                if (parsed) {
                    prepared[key] = { ...prepared[key], new: parsed.format() }
                } else {
                    delete prepared[key]
                    refetch = true
                }
            })
            return { data: prepared, refetch }
        },

        requestWindowSnapshot(refetch) {
            if (refetch && typeof this.refreshWindowSnapshot === 'function')
                this.refreshWindowSnapshot()
        },

        setTrackOrder(isCanteen, event) {
            let model = isCanteen ? this.trackOrder.model.canteenMasterOrder : this.trackOrder.model
            model.deliveryJob = this.getResult(model.deliveryJob, event.data, this.trackerMap)
            if (!model.deliveryJob.id) model.deliveryJob.id = event.id
            if (isCanteen) this.$set(this.trackOrder.model, 'canteenMasterOrder', model)
            else this.$set(this.trackOrder, 'model', model)
        },

        async updateOrder(event) {
            const { data: orderData, refetch } = this.prepareWindowDiff(event.data)
            this.order.model = this.getResult(this.order.model, orderData, this.orderMap)
            await this.$store.dispatch(`${this.namespace}/setOrder`, this.order.model)
            if (
                Object.keys(event.data).some((key) => this.thirdPartyOrderVariables.includes(key))
            ) {
                this.trackOrder.model = this.getResult(
                    this.trackOrder.model,
                    { ...event.data },
                    this.thirdPartyOrderMap
                )
                await this.$store.dispatch(`${this.namespace}/setTracking`, this.trackOrder.model)
            }
            await this.updateStatus()
            this.requestWindowSnapshot(refetch)
        },

        async updateTracker(event) {
            const { data, refetch } = this.prepareWindowDiff(event.data)
            this.setTrackOrder(!!this.trackOrder.model.canteenMasterOrder, { ...event, data })
            await this.$store.dispatch(`${this.namespace}/setTracking`, this.trackOrder.model)
            await this.updateStatus()
            this.requestWindowSnapshot(refetch)
        },
    },
}
